import Select from "@/components/Select";
import React from "react";

export interface PriorityRuleFormValue {
  priority: number;
}

interface Props {
  label: string;
  updateValue: (value: PriorityRuleFormValue) => void;
  value: PriorityRuleFormValue;
}

const PRIORITY_OPTIONS = {
  "1": "High — bypass tier escalation, highlighted badge",
  "2": "Urgent — highest priority, alerted to all agents immediately"
};

export default function PriorityRuleForm({ label, value, updateValue }: Props) {
  return (
    <>
      <div>{label}</div>
      <div className="flex flex-col gap-2 mr-auto">
        <div className="text-sm text-slate-600">
          Matching conversations will be flagged as priority. High-priority conversations skip
          tier escalation and show a badge in the agent inbox.
        </div>
        <div className="flex items-center gap-2">
          <span className="text-sm text-slate-700 whitespace-nowrap">Set priority to:</span>
          <Select
            options={PRIORITY_OPTIONS}
            value={String(value?.priority ?? 1)}
            onChange={(v) => updateValue({ priority: Number(v) })}
          />
        </div>
        <div className="text-xs text-slate-400">
          Priority 1 = High (bypasses tier escalation). Priority 2 = Urgent (alerted to all
          available agents immediately, shown with urgent badge).
        </div>
      </div>
    </>
  );
}
